const NON_STRIPE_CHECKOUT_PAYMENT_METHODS = ['post-pay', 'allowance', 'yearly-allowance'];

export const isStripeCheckoutPayment = (type?: string) => {
  return !!type && !NON_STRIPE_CHECKOUT_PAYMENT_METHODS.includes(type);
};
